import styled from 'styled-components';

import { black, border1, green, red } from 'utils/style/colors';

import Icon from 'components/Icon';

export const EditorHeader = styled.div`
  width: 100%;
  padding: 1.25rem 1.25rem 1.25rem 1.25rem;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  border-bottom: ${border1};
  justify-content: space-between;
  @media only screen and (max-width: 600px) {
    padding: 1.25rem 4rem 1.25rem 1.25rem;
  }
`;

export const TaskOptionsIcon = styled(Icon)`
  cursor: pointer;
  margin: 0 0.3em !important;
  font-size: 1.3em !important;
  transition: 0.3s all ease;
  :hover {
    color: ${green} !important;
  }
`;

export const SmartScheduleIcon = styled(TaskOptionsIcon)``;

export const HoverHighlight = styled('span')`
  &:hover {
    color: ${({ color }) => color} !important;
  }
`;

export const TaskOptions = styled.div`
  display: flex;
  margin-inline-start: auto;
  position: relative;
  align-items: center;
  flex-grow: 1;
  flex-wrap: wrap;
`;

export const DropdownPrintIcon = styled.div`
  padding: 0;
  overflow: hidden;
`;

export const PrintLoaderSpinner = styled.span`
  padding: 0 0.5rem;
`;

export const PrintLoaderContainer = styled.span`
  display: flex !important;
  & > a {
    color: ${black};
  }
`;

export const PrintLink = styled.a`
  display: flex;
  align-items: center;

  & > * {
    padding: 0 0.5rem;
  }
`;

export const InformativeBadge = styled.span`
  position: absolute;
  bottom: -0.15rem;
  left: 0.15rem;
  width: 0.65rem;
  height: 0.65rem;
  border-radius: 10rem;
  background: ${red};
`;

export const UploadFileProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 30rem;
  background: var(--exact-white);
  padding: 0.5rem;
`;

export const UploadFileRow = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem 0.75rem;
  height: 2.5rem;
  border-inline-start: 3px solid ${green};
`;
